import Table from 'components/Table'
import { StyledTableWrapper } from './Transactions'
import { useGetExplorerService } from 'services/usePaymentService'
import styled from 'styled-components'
import React from 'react'

export const getTotalPages = (limit: number, total_count: number) =>
    total_count > limit ? Math.ceil(total_count / limit) : null

const Explorer = () => {
    const [filter, setFilter] = React.useState({
        page: 1,
        limit: 20,
    })
    const { data: explorerData, loading } = useGetExplorerService(filter)

    const { total_count, items } = explorerData

    const data = items?.map((item: any) => ({
        ...item,
        is_charged: item.is_charged ? 'Succeeded' : 'Pending',
        amount:
            item.price_per === 'token'
                ? (item.current_usage * item.usage_price) / item.limit
                : item.current_usage * item.usage_price,
        created_on: new Date(item.created_on).toLocaleString(),
    }))

    const setPage = (pageNumber: number) => {
        setFilter({ ...filter, page: pageNumber })
    }

    const total_pages = getTotalPages(filter.limit, total_count)

    return (
        <StyledTableWrapper>
            <Table 
                columns={base} 
                data={data} 
                isLoading={loading}
                page={filter.page}
                totalPages={total_pages}
                setPage={setPage} 
            />
        </StyledTableWrapper>
    )
}
export default Explorer

const base = [
    {
        Header: 'Subnet',
        accessor: 'subnet_name',
        minWidth: 150,
        width: 200,
    },
    {
        Header: 'Date',
        accessor: 'created_on',
        minWidth: 50,
        width: 100,
    },
    {
        Header: 'Amount',
        accessor: 'amount',
        minWidth: 50,
        width: 100,
    },
    {
        Header: 'Charge',
        accessor: 'is_charged',
        minWidth: 50,
        width: 100,
        Cell: ({ value }: { value: string }) => (
            <StatusParagraph value={value}>{value}</StatusParagraph>
        ),
    },
]

const StatusParagraph = styled.p<{ value: string }>`
    height: 100%;
    display: flex;
    align-items: center;

    color: ${({ value, theme }) =>
        value === 'Succeeded' ? theme.foundation.positive : theme.foundation.warning};
`
